package com.milta.feature.optimizationquota.presentation

import com.milta.core.network.ApiException
import com.milta.core.network.PagedResult
import com.milta.feature.optimizationquota.domain.entity.OptimizationHistoryEntry

/** R13 — the history is always read page by page while scrolling, never in one go. */
const val OPTIMIZATION_HISTORY_PAGE_SIZE = 10

/**
 * MIL-97 — paged optimization history, shared by "Mes optimisations" (mobile + web) and the Admin
 * "Fiche utilisateur". [error] is "server_error" | "offline" for the last page request.
 */
data class OptimizationHistoryState(
    val items: List<OptimizationHistoryEntry> = emptyList(),
    val totalCount: Int = 0,
    val loadedPages: Int = 0,
    val isLoadingPage: Boolean = false,
    val error: String? = null,
) {
    val hasMore: Boolean get() = loadedPages == 0 || items.size < totalCount
    val nextPage: Int get() = loadedPages + 1
    val isEmpty: Boolean get() = loadedPages > 0 && items.isEmpty()

    fun withPage(page: PagedResult<OptimizationHistoryEntry>): OptimizationHistoryState {
        val known = items.map { it.id }.toSet()
        val merged = items + page.items.filterNot { it.id in known }
        // An empty page before totalCount is reached (rows removed meanwhile) ends the list
        // instead of asking for the same page forever.
        val total = if (page.items.isEmpty()) merged.size else page.totalCount
        return copy(items = merged, totalCount = total, loadedPages = page.page, isLoadingPage = false, error = null)
    }

    fun withError(e: Throwable): OptimizationHistoryState =
        copy(isLoadingPage = false, error = if (e is ApiException) "server_error" else "offline")
}
